import { useQuery } from '@tanstack/react-query'
import { requireResourceText } from './api/resource/client'

const useResource = (resourceKey: string | undefined) => {
  const query = useQuery({
    queryKey: ['resourceContent', resourceKey],
    queryFn: () => requireResourceText(resourceKey!),
    enabled: !!resourceKey,
    staleTime: Infinity,
  })

  return { content: query.data, isLoading: query.isLoading, error: query.error }
}

export default useResource
